import React from "react";
import "./Features_Section.css";
import { useSelector } from "react-redux";

const FeaturesSection = () => {


const product = useSelector((state) => state.product?.product?.Product_Fetures);

  

  const features = [
    {
      title: "Anti Sag Technology",
      description:
        "Anti Sag Technology is designed to prevent the mattress from losing its shape and firmness over time. By using high-quality, durable materials and reinforcing key areas, this feature helps maintain consistent support and prevents sagging, ensuring that your mattress remains comfortable and supportive for a longer period, even with regular use.",
      image: "/assets/images/hospitality/artho.png",
    },
    {
      title: "Sweat Free Sleep",
      description:
        "Anti Sag Technology is designed to prevent the mattress from losing its shape and firmness over time. By using high-quality, durable materials and reinforcing key areas, this feature helps maintain consistent support and prevents sagging, ensuring that your mattress remains comfortable and supportive for a longer period, even with regular use.",
      image: "/assets/images/hospitality/artho.png",
    },
    {
      title: "Responsive Bounce & Lasting Support",
      description:
        "Anti Sag Technology is designed to prevent the mattress from losing its shape and firmness over time. By using high-quality, durable materials and reinforcing key areas, this feature helps maintain consistent support and prevents sagging, ensuring that your mattress remains comfortable and supportive for a longer period, even with regular use.",
      image: "/assets/images/hospitality/artho.png",
    },
    {
      title: "Hygienic Sleep Surface",
      description:
        "Anti Sag Technology is designed to prevent the mattress from losing its shape and firmness over time. By using high-quality, durable materials and reinforcing key areas, this feature helps maintain consistent support and prevents sagging, ensuring that your mattress remains comfortable and supportive for a longer period, even with regular use.",
      image: "/assets/images/hospitality/artho.png",
    },
  ];


  console.log(product ,"data for featuressss");

  return (
    <section className="features-section">
      <div className="container">
        {product?.map((item, index) => (
          <div className="feature-block" key={index}>
            <div
              className={`row align-items-center ${
                index % 2 !== 0 ? "reverse" : ""
              }`}
            >
              <div className="col-lg-6 col-md-6 col-12 p-0">
                <div className="feature-img">
                  {/* <img src={item.image} alt={item.title} /> */}
                  <img src={process.env.REACT_APP_IMG_URL + item?.image} alt={item?.name} />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12 p-0">
                <div className="feature-text">
                  <h3 className="title">{item?.name}</h3>
                  <p className="text">  {item?.description?.replace(/<[^>]+>/g, "")}</p>
                  
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
